import React, { useState } from 'react';
import Board from './Board';
import Login from './Login';
import '../assets/styles/game.css';
import Endgame from './Endgame';
import History from './History';
import { useLocalStorage } from '../helpers/useLocalStorage';


const initial = '';
const player1 = 'X';
const player2 = 'O';
const winCombinations = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
]

function TicTacToe() {
  const [grid, setGrid] = useState(Array(9).fill(initial));
  const [player, setPlayer] = useState(true);
  const [gameOver, setGameOver] = useState(false);
  const [winCount, setWinCount] = useState({ player1: 0, player2: 0, tie: 0 });
  const [players, setPlayers] = useLocalStorage("tictactoe_players", { playerOne: 'Player1', playerTwo: 'Player2' });
  const [inputPlayers, setInputPlayers] = useState({ playerOne: '', playerTwo: '' });
  const [winner, setWinner] = useState("");
  const [login, setLogin] = useState(false);
  const [showhistory, setShowHistory] = useState(false);
  const [historyLog, setHistoryLog] = useLocalStorage('tictactoe_history', []);




  function handleChange(e) {
    const newValue = e.target.value;
    const inputName = e.target.name;



    setInputPlayers(prevValue => {
      if (inputName === 'playerOne') {
        return {
          playerOne: newValue,
          playerTwo: prevValue.playerTwo
        };
      } else if (inputName === 'playerTwo') {
        return {
          playerOne: prevValue.playerOne,
          playerTwo: newValue
        }
      }
    })
  }


  function playTheGame() {
    if (!(inputPlayers.playerOne === "" || inputPlayers.playerTwo === "")) {
      setLogin(true);
      setPlayers(inputPlayers);
    }
  }


  function isGameOver() {
    if (!gameOver) {

      //check x win 
      for (let i = 0; i < 8; i++) {
        if (
          grid[winCombinations[i][0]] === player1 &&
          grid[winCombinations[i][1]] === player1 &&
          grid[winCombinations[i][2]] === player1
        ) {
          setGameOver(true);
          setWinCount({ ...winCount, player1: winCount.player1 + 1 });
          setWinner(players.playerOne + " won!");
          setHistoryLog([...historyLog, datePlayers() + players.playerOne + " won!"]);
          return;
        }
      }

      //check o win 
      for (let i = 0; i < 8; i++) {
        if (
          grid[winCombinations[i][0]] === player2 &&
          grid[winCombinations[i][1]] === player2 &&
          grid[winCombinations[i][2]] === player2
        ) {
          setGameOver(true);
          setWinCount({ ...winCount, player2: winCount.player2 + 1 });
          setWinner(players.playerTwo + " won!");
          setHistoryLog([...historyLog, datePlayers() + players.playerTwo + " won!"])
          return;
        }
      }
      //check tie
      if (!grid.includes(initial)) {
        setWinner("It's a tie!")
        setGameOver(true);
        setWinCount({ ...winCount, tie: winCount.tie + 1 });
        setHistoryLog([...historyLog, datePlayers() + "Tie game!"])
      }
    }
  }
  isGameOver();

  function playAgain() {
    setGrid((Array(9).fill(initial)));
    setPlayer(true);
    setGameOver();
    setShowHistory(false)
  }


  function handleClick(id) {
    if (login) {

      setGrid(
        grid.map((item, index) => {
          if (index === id) {
            if (player) {
              return player1;
            } else {
              return player2;
            }
          } else {
            return item;
          }
        }));
      setPlayer(!player);
    }

  }

  function reset() {
    setGrid((Array(9).fill(initial)));
    setGameOver(false);
    setLogin(false);
    setWinCount({ player1: 0, player2: 0, tie: 0 });
    setPlayers({ playerOne: 'Player1', playerTwo: 'Player2' });
    setInputPlayers({ playerOne: '', playerTwo: '' });
    setShowHistory(false);
    setHistoryLog([])
  }



  function datePlayers() {
    let d = new Date();
    let newHistoryLine = d.getFullYear() + '  ' + d.getDate() + ':' + d.getMinutes();
    newHistoryLine += ` | ${players.playerOne} vs ${players.playerTwo} | `
    return newHistoryLine;

  }


  return (

    <div>
      <div className="container-tictactoe">
        <div className="player-tictactoe"> {players.playerOne}: {winCount.player1}</div>
        <div className="player-tictactoe">{players.playerTwo}: {winCount.player2}</div>
        <div className="player-tictactoe">Ties: {winCount.tie}</div>
      </div>

      < Login
        players={inputPlayers}
        handleChange={handleChange}
        playTheGame={playTheGame}
        trigger={!login}
      />

      <Board

        clickedGrid={grid}
        handleClick={handleClick}

      />

      <Endgame

        title={winner}
        playAgain={playAgain}
        reset={reset}
        trigger={gameOver}
        setShowHistory={setShowHistory}

      />
      <History
        opponent1={players.playerOne}
        opponent2={players.playerTwo}
        showhistory={showhistory}
        setShowHistory={setShowHistory}
        historyLog={historyLog}
      />
    </div>
  );
}



export default TicTacToe;